import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { EMPTY, catchError } from 'rxjs';

import { HeadlineService } from '../services/headline.service';

@Injectable({
  providedIn: 'root',
})
export class HeadlineResolver {
  private headlineService = inject(HeadlineService);
  private router = inject(Router);

  resolve(route: ActivatedRouteSnapshot) {
    return this.headlineService.getHeadlineById(route.params.id).pipe(
      catchError((_error: unknown) => {
        this.router.navigate(['/headlines']);
        return EMPTY;
      })
    );
  }
}
